export function isEmptyElInObj(obj, arrName) {
  return Object.keys(obj[arrName]).length === 0;
}
